import { ItemLocationInput } from '../../generated/graphql-types';
import { ItemLocation } from '../types/enums';

export type GameMoveValidation = { ok: true } | { ok: false; errorKey: string };

export const GameMoveErrorKey = {
  EQUIP_SLOT_MISMATCH: 'server.illegal.equip_slot_mismatch',
  BAG_SELF_REFERENCE: 'server.illegal.bag_self_reference',
  BAG_CIRCULAR_REFERENCE: 'server.illegal.bag_circular_reference',
  BAG_SLOT_BAGS_ONLY: 'server.illegal.bag_slot_bags_only',
} as const;

export function validateEquipMove(
  itemSlot: ItemLocationInput['slot'],
  toSlot: ItemLocationInput['slot']
): GameMoveValidation {
  if (!itemSlot || itemSlot !== toSlot) {
    return { ok: false, errorKey: GameMoveErrorKey.EQUIP_SLOT_MISMATCH };
  }
  return { ok: true };
}

export function validateBagSlotMove(
  fromItem: { slot?: string | null; type: string },
  to: ItemLocationInput
): GameMoveValidation {
  if (
    (to.location === ItemLocation.GLOBAL_BAG_SLOT || to.location === ItemLocation.HERO_BAG_SLOT) &&
    !(fromItem.slot === 'item_container' && fromItem.type === 'bag')
  ) {
    return { ok: false, errorKey: GameMoveErrorKey.BAG_SLOT_BAGS_ONLY };
  }
  return { ok: true };
}

export function validateBagEquipMove(
  from: ItemLocationInput,
  to: ItemLocationInput
): GameMoveValidation {
  if (
    from.location === ItemLocation.GLOBAL_INVENTORY &&
    to.location === ItemLocation.GLOBAL_BAG_SLOT &&
    from.bag_index !== undefined &&
    to.bag_slot_index !== undefined &&
    from.bag_index === to.bag_slot_index
  ) {
    return { ok: false, errorKey: GameMoveErrorKey.BAG_CIRCULAR_REFERENCE };
  }
  if (
    from.location === ItemLocation.HERO_INVENTORY &&
    to.location === ItemLocation.HERO_BAG_SLOT &&
    from.hero_handle === to.hero_handle &&
    from.bag_index !== undefined &&
    to.bag_slot_index !== undefined &&
    from.bag_index === to.bag_slot_index
  ) {
    return { ok: false, errorKey: GameMoveErrorKey.BAG_CIRCULAR_REFERENCE };
  }
  return { ok: true };
}
